import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  useTheme,
  alpha,
  IconButton,
  Stack,
  Divider,
} from "@mui/material";
import SpaIcon from "@mui/icons-material/Spa";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

export const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: alpha(theme.palette.primary.dark, 0.95),
        color: alpha("#ffffff", 0.8),
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          {/* Coluna 1: Logo e Descrição */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <SpaIcon
                sx={{ color: theme.palette.secondary.light, fontSize: 30 }}
              />
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#ffffff" }}
              >
                Saúde Vital
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 3, maxWidth: 320 }}>
              Consultoria especializada em planos de saúde. Encontre a proteção
              ideal com as melhores condições do mercado.
            </Typography>
            <Stack direction="row" spacing={1}>
              {[FacebookIcon, InstagramIcon, LinkedInIcon, WhatsAppIcon].map(
                (Icon, index) => (
                  <IconButton
                    key={index}
                    aria-label={Icon.name?.replace("Icon", "").toLowerCase()}
                    sx={{
                      color: alpha("#ffffff", 0.7),
                      backgroundColor: alpha("#ffffff", 0.1),
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#ffffff",
                        backgroundColor: theme.palette.secondary.main,
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Icon fontSize="small" />
                  </IconButton>
                )
              )}
            </Stack>
          </Grid>

          {/* Coluna 2: Links Rápidos */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#ffffff", mb: 2.5 }}
            >
              Links
            </Typography>
            <Stack spacing={1.5}>
              {[
                "Vantagens",
                "Coberturas",
                "Rede Credenciada",
                "FAQ",
                "Contato",
              ].map((item) => (
                <Link
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "-")}`}
                  underline="hover"
                  sx={{
                    color: alpha("#ffffff", 0.8),
                    "&:hover": { color: theme.palette.secondary.light },
                  }}
                >
                  {item}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Coluna 3: Tipos de Planos */}
          <Grid item xs={6} md={3}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#ffffff", mb: 2.5 }}
            >
              Tipos de Planos
            </Typography>
            <Stack spacing={1.5}>
              {[
                "Individual",
                "Familiar",
                "Empresarial",
                "Odontológico",
                "Por Adesão",
              ].map((item) => (
                <Link
                  key={item}
                  href="#planos"
                  underline="hover"
                  sx={{
                    color: alpha("#ffffff", 0.8),
                    "&:hover": { color: theme.palette.secondary.light },
                  }}
                >
                  {item}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Coluna 4: Contato */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#ffffff", mb: 2.5 }}
            >
              Contato
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <PhoneEnabledIcon
                  sx={{ color: theme.palette.secondary.light, fontSize: 20 }}
                />
                <Typography variant="body2">(11) 3333-4444</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <WhatsAppIcon
                  sx={{ color: theme.palette.secondary.light, fontSize: 20 }}
                />
                <Typography variant="body2">(11) 93333-4444</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <MailOutlineIcon
                  sx={{ color: theme.palette.secondary.light, fontSize: 20 }}
                />
                <Typography variant="body2">
                  contato@saudevital.com.br
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <LocationOnOutlinedIcon
                  sx={{ color: theme.palette.secondary.light, fontSize: 20 }}
                />
                <Typography variant="body2">
                  Av. Saúde, 123 - São Paulo/SP
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: alpha("#ffffff", 0.2) }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: alpha("#ffffff", 0.7) }}>
            © {currentYear} Saúde Vital. Todos os direitos reservados.
          </Typography>
          <Typography variant="body2" sx={{ color: alpha("#ffffff", 0.7) }}>
            Desenvolvido por{" "}
            <Link
              href="#"
              color="inherit"
              sx={{ fontWeight: 600, color: theme.palette.secondary.light }}
            >
              Dev Health
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
